import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { useTranslation } from "react-i18next";

const StackedBarChart = (props) => {
    const { t:translate, i18n } = useTranslation();
  const options = {
    colors : ['#E77B2B', '#EFA92C','#7DBC7B', '#D8565B', '#93212B'],
    chart: {
        type: 'bar',
        height: 350,
        width:'100%',
        stacked: true,
        stackType: '100%',
        toolbar: {
            show: false,
        },
    },
    plotOptions: {
        bar: {
            horizontal: true,
        },
    },
    stroke: {
        width: 1,
        colors: ['#fff']
    },
    title: {
        text: ''
    },
    xaxis: {
        categories:['']
    },
    
    
    fill: {
        opacity: 1
    },
    legend: {
        position: 'top',
        horizontalAlign: 'left',
        offsetX: 40
    }
  };

  const series = [
    {
        name: translate('very_high'),
        data: [props.stackedGraphData.countVeryHighPercent]
    }, 
    {
        name: translate('high'),
        data: [props.stackedGraphData.countHighPercent]
    }, 
    {
        name: translate('target_range'),
        data: [props.stackedGraphData.countTargetPercent]
    }, 
    {
        name: translate('low'),
        data: [props.stackedGraphData.countLowPercent]
    }, 
    {
        name: translate('very_low'),
        data: [props.stackedGraphData.countVeryLowPercent]
    }
  ];

  return (
    <div style={{width:'100%' , height:'100%'}}>
        <ReactApexChart options={options} series={series} type="bar" height={'80%'} width={'100%'}/>
    </div>
    
  );
};

export default StackedBarChart;
